/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

/**
 * All supported event modes for the @pixi/events module.
 * These are intended to replace displayObject.interactive property.
 * Usage: `displayObject.eventMode = EventModes.Static;`
 * - 'none': Ignores all interaction events, even on its children.
 * - 'passive': Does not emit events and ignores all hit testing on itself and non-interactive children. Interactive children will still emit events.
 * - 'auto': Does not emit events but is hit tested if parent is interactive. Same as interactive = false in v7
 * - 'static': Emit events and is hit tested. Same as interaction = true in v7
 * - 'dynamic': Emits events and is hit tested but will also receive mock interaction events fired from a ticker to allow for interaction when the mouse isn't moving
 */
export enum EventMode {
	None = `none`,
	Passive = `passive`,
	Auto = `auto`,
	Disabled = `auto`, // Alias for `auto`, easier to read without context
	Static = `static`,
	Dynamic = `dynamic`,
}
